import React from "react";

export default function TableSkeleton({ columns = 8, rows = 10 }) {
  const skeletonCells = Array.from({ length: columns }, (_, i) => (
    <td key={i} className="px-3 py-4">
      <div className="h-4 bg-gray-200 rounded animate-pulse w-full max-w-xs" />
    </td>
  ));

  const skeletonHeader = Array.from({ length: columns }, (_, i) => (
    <th key={i} scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
      <div className="h-4 bg-gray-200 rounded animate-pulse w-3/4" />
    </th>
  ));

  const skeletonRows = Array.from({ length: rows }, (_, rowIndex) => (
    <tr key={rowIndex} className={rowIndex % 2 === 0 ? "bg-gray-50" : "bg-white"}>
      {skeletonCells}
    </tr>
  ));

  return (
    <table className="min-w-full divide-y divide-gray-300">
      <thead className="bg-gray-50">
        <tr>{skeletonHeader}</tr>
      </thead>
      <tbody className="divide-y divide-gray-200">{skeletonRows}</tbody>
    </table>
  );
}